"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calculation = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Calculation(_a) {
    var billing = _a.billing;
    return react_1.default.createElement("div", { className: 'grid grid-cols-2 mt-md' },
        react_1.default.createElement("div", { className: 'col-start-2 pt-sm' },
            react_1.default.createElement(storybook_1.Billings.TextBlock, null,
                react_1.default.createElement("div", { className: 'flex justify-between' },
                    react_1.default.createElement("div", { className: 'text-gray-500' },
                        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h4', className: 'text-gray-500' }, "Subtotaal")),
                    react_1.default.createElement(storybook_1.Texts.Primary, { className: 'text-black', html: true }, billing.prices.sub_total)),
                react_1.default.createElement(storybook_1.Billings.Divider, null)),
            react_1.default.createElement(storybook_1.Billings.TextBlock, null,
                react_1.default.createElement("div", { className: 'flex justify-between' },
                    react_1.default.createElement("div", { className: 'text-gray-500' },
                        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h4', className: 'text-gray-500' }, "BTW 21%")),
                    react_1.default.createElement(storybook_1.Texts.Primary, { className: 'text-black', html: true }, billing.prices.tax)),
                react_1.default.createElement(storybook_1.Billings.Divider, null)),
            react_1.default.createElement(storybook_1.Billings.TextBlock, null,
                react_1.default.createElement("div", { className: 'flex justify-between' },
                    react_1.default.createElement("div", { className: 'text-gray-500' },
                        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h4', className: 'text-gray-500' },
                            "Totaal te ",
                            billing.negative ? 'betalen' : 'ontvangen')),
                    react_1.default.createElement(storybook_1.Texts.Primary, { className: 'text-black', html: true }, billing.prices.total)),
                react_1.default.createElement(storybook_1.Billings.Divider, null))));
}
exports.Calculation = Calculation;
